import { DebinPayment } from 'screens/Home/Debin/types'
import { SaleOrder } from 'store/contracts/types'
import { AuthorizationStatus, CancelationStatus, Recurrence, RecurrenceStatus } from 'store/debin/types'

export enum Drawers {
  CONFIRM_NEW_SALE_ORDER = 'CONFIRM_NEW_SALE_ORDER',
  SALE_ORDER_SUCCESS = 'SALE_ORDER_SUCCESS',
  SALE_ORDER_ERROR = 'SALE_ORDER_ERROR',
  SALE_ORDER_DETAILS = 'SALE_ORDER_DETAILS',
  COUNTER_OFFER_SALE_ORDER = 'COUNTER_OFFER_SALE_ORDER',
  OUT_OF_TIME = 'OUT_OF_TIME',
  QUOTA_DETAILS = 'QUOTA_DETAILS',
  QUOTA_CREATE_SUCCESS = 'QUOTA_CREATE_SUCCESS',
  HOW_WORKS_QUOTA = 'HOW_WORKS_QUOTA',
  APPLICATIONS_DETAILS = 'APPLICATIONS_DETAILS',
  LIQUIDATIONS_DETAILS = 'LIQUIDATIONS_DETAILS',
  FILTER_DATE = 'FILTER_DATE',
  DOWNLOAD_DEBIN = 'DOWNLOAD_DEBIN',
  DEBIN_DETAIL = 'DEBIN_DETAIL',
  DEBIN_OPERATION_SUCCESS = 'DEBIN_OPERATION_SUCCESS',
  DEBIN_OPERATION_ERROR = 'DEBIN_OPERATION_ERROR',
  REPRESENTED_DETAIL = 'REPRESENTED_DETAIL',
  RECEIPT_DETAIL = 'RECEIPT_DETAIL',
  EMAIL_SENT_SUCCESS = 'EMAIL_SENT_SUCCESS',
  EMAIL_SENT_ERROR = 'EMAIL_SENT_ERROR',
  DOCUMENTS_SENT_SUCCESS = 'DOCUMENTS_SENT_SUCCESS',
  DOCUMENTS_SENT_ERROR = 'DOCUMENTS_SENT_ERROR',
  ADD_HUMAN_PERSON_SUCCESS = 'ADD_HUMAN_PERSON_SUCCESS',
  ADD_HUMAN_PERSON_ERROR = 'ADD_HUMAN_PERSON_ERROR',
  INVESTMENT_DETAIL = 'INVESTMENT_DETAIL'
}

export enum DrawerActionTypes {
  SHOW_DRAWER = '@DRAWER:SHOW_DRAWER',
  HIDE_DRAWER = '@DRAWER:HIDE_DRAWER'
}

export enum OperationType {
  DEBIN_CONFIRMATION = 'DEBIN CONFIRMATION',
  DEBIN_CANCELATION = 'DEBIN CANCELATION'
}

export interface Action {
  type: string
  payload: any
}

interface Data {
  [Drawers.CONFIRM_NEW_SALE_ORDER]: {
    saleOrder: SaleOrder
  }
  [Drawers.FILTER_DATE]: {
    fromInvestmentSummary?: boolean
  }
  [Drawers.DOWNLOAD_DEBIN]: {
    debinData?: DebinPayment[]
  }
  [Drawers.DEBIN_DETAIL]: {
    debinData?: {
      externalId: string
      company: string
      date: string
      amount: number
      installments: number
      concept: string
      status: RecurrenceStatus
      authorizationStatus: AuthorizationStatus
      cancellationStatus: CancelationStatus
      hasQuoteInProgress: boolean
    }
  }
  [Drawers.DEBIN_OPERATION_ERROR]: {
    debinData?: {
      externalId: string
      company: string
      date: string
      amount: number
      installments: number
      concept: string
      status: RecurrenceStatus
      authorizationStatus: AuthorizationStatus
      cancellationStatus: CancelationStatus
      operationType: OperationType
      isAccepted: boolean
    }
  }
  [Drawers.DEBIN_OPERATION_SUCCESS]: {
    debinData?: {
      recurrence: Recurrence
      isRefund: boolean
      operationType: OperationType
      isAccepted: boolean
    }
  }
}

export interface DrawerState {
  actives: Drawers[]
  data: Partial<Data>
}
